import TranslateCommandParamsOpenApiModel = OperatorApplicationApi.TranslateCommandParamsOpenApiModel;
import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;

export default function getTranslateCommandParams(client: OperatorApplicationClientOpenApiModel, text: string): TranslateCommandParamsOpenApiModel | null {
    let languageIsoCode = client.languageIsoCode;
    if (languageIsoCode) {
        return {
            text,
            languageIsoCode
        };
    }
    return null;
}